import { render, staticRenderFns } from "./TransitionQuestions.vue?vue&type=template&id=b6bfc04c&"
import script from "./TransitionQuestions.vue?vue&type=script&lang=js&"
export * from "./TransitionQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports